module.exports = __webpack_public_path__ + "be16a92a30c03b751abf41550fa0d648.svg";